import { useState } from 'react'
import moment from "moment"
import EmailEditorHtml from "./email-editor"
import Loading from '../../components/Loading'
import { Notification, notify } from '../../utils/notification';
import Modal from '../../components/Modal/official'

const ITEMS_PER_PAGE = 10;

export default function Templates({ admin, templates, templatePagination, saveTemplate, refreshList, removeTemplate }) {

  const [editor, setEditor] = useState(false);
  const [templateSelected, setTemplateSelected] = useState({});
  const [notification, setNotification] = useState({});
  const [deleting, setDeleting] = useState({ active: false, templateId: null });

  const pagination = templatePagination || { total: 0, page: 1, limit: ITEMS_PER_PAGE };
  const totalPages = Math.ceil(pagination.total / pagination.limit) || 1;
  const currentPage = pagination.page;

  function closeEditor() {
    setEditor(false)
    setTemplateSelected({})
    refreshList(currentPage, pagination.limit)
  }

  function createNewTemplate() {
    setEditor(true)
    setTemplateSelected({})
  }

  function handlePageChange(page) {
    if (page >= 1 && page <= totalPages) refreshList(page, pagination.limit);
  }

  function handleRemove(templateId) {
    removeTemplate(templateId, admin.loja, (response) => {
      refreshList(currentPage, pagination.limit);
      setDeleting({ active: false, templateId: null });
      return notify("Template excluído com sucesso!", setNotification);
    })
  }

  return !templates ? <Loading /> : (
    <div className="templates">
      <Notification notification={notification} />
      <div className="section-actions">
        <button onClick={createNewTemplate}><i className="fas fa-plus"></i> Criar Novo</button>  
      </div>
      { templates.map((template) => (
        <div className="template" key={template._id}>
          <div className="information">
            <h1>{template.title}</h1>
            { template.createdAt === template.updatedAt ? (
              <p><span className="status createdAt">Adicionada em</span> {moment(template.createdAt).format("DD/MM/YYYY")} às {moment(template.createdAt).format("HH:mm")}</p>
            ) : (
              <p><span className="status updatedAt">Atualizada em</span> {moment(template.updatedAt).format("DD/MM/YYYY")} às {moment(template.updatedAt).format("HH:mm")}</p>
            )}
            <div className="actions">
              <button className="edit" onClick={() => { setTemplateSelected({ _id: template._id, title: template.title, design: template.design }); setEditor(true) }}>Editar Template</button>
              <button className="remove" onClick={() => setDeleting({ active: true, templateId: template._id })}>Excluir</button>
            </div>
          </div>
          <div className="preview">
            <div className="preview-html-overlay"></div>
            <div className="preview-html" dangerouslySetInnerHTML={{ __html: template.html}}></div>
          </div>
        </div>
      )) }

      { totalPages > 1 && (
        <div className="templates-pagination">
          <button
            disabled={currentPage <= 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            <i className="fas fa-chevron-left"></i> Anterior
          </button>
          <span className="pagination-info">
            Página {currentPage} de {totalPages} ({pagination.total} templates)
          </span>
          <button
            disabled={currentPage >= totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Próxima <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      )}

      <Modal text="Deseja realmente excluir este template?" active={deleting.active ? true : false} close={() => setDeleting({ active: false, templateId: null })} confirm={() => handleRemove(deleting.templateId)} />

      {editor && (
        <EmailEditorHtml
          active={editor}
          templateSelected={templateSelected}
          setTemplateSelected={setTemplateSelected}
          closeEditor={closeEditor}
          admin={admin}
          saveTemplate={saveTemplate}
        />
      )}

    </div>
  )
}